var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhitepaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    id: "whitepaper_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".whitepaper_svg__st7{fill-rule:evenodd;clip-rule:evenodd;fill:#aeaeae}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "whitepaper_svg__a_1_",
    cx: 17,
    cy: 22.6,
    r: 18,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "whitepaper_svg__Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0.6,
    y: 9.8,
    width: 32.6,
    height: 40
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.6,
    y: 9.8,
    width: 32.6,
    height: 40,
    id: "whitepaper_svg__b_1_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#whitepaper_svg__Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "whitepaper_svg__a_2_",
    cx: 11.5,
    cy: 22.6,
    r: 18,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#whitepaper_svg__b_1_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 11l25.9-4.1 5.3 33.7-25.9 4L-1 11z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#706aaf",
    transform: "translate(1.55 5.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 7.7l26.1-2.3 3 34L5 41.7l-3-34z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#42318c",
    transform: "translate(1.55 5.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4 4.6h26.2v34.2H5.4V4.6z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#efefef",
    transform: "translate(1.55 5.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "whitepaper_svg__st7",
    d: "M8.5 11.2h11v1h-11v-1zM8.6 14.8H24v1H8.6v-1zM8.5 16.5H28v1H8.5v-1zM8.5 18.2h8.2v1H8.5v-1zM8.5 22.2h7v1h-7v-1zM8.6 23.8h16.3l-1 1H8.6v-1zM8.6 28.7h15.3v1H8.6v-1zM8.5 25.4h8.2v1H8.5v-1zM8.5 27h12.4v1H8.5v-1zM18.2 25.4H28v1h-9.8v-1zM18.2 18.2h8.2v1h-8.2v-1z",
    transform: "translate(1.55 5.25)"
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgWhitepaper as ReactComponent };